<script setup>
import SocialPrefixes from '@enums/social-prefixes'

defineProps({
    artist: {
        type: Object,
        default: () => ({}),
    },
})

const prefixes = SocialPrefixes
</script>


<template>
    <BaseContent>
        <BaseSection
            padded
            title="Biography"
        >
            <div v-if="artist.biography && artist.biography.length">
                <p
                    v-safe-html="artist.biography"
                    class="info"
                />
            </div>
            <div v-else>
                <p>This artist does not have a bio yet.</p>
            </div>
            <div class="social-media">
                <BaseLink
                    v-if="artist.facebook_username && artist.facebook_username.length"
                    :href="`${prefixes.FACEBOOK}${artist.facebook_username}`"
                    class="icon-container"
                >
                    <BaseIcon
                        class="icon"
                        name="logo-facebook"
                    />
                </BaseLink>
                <BaseLink
                    v-if="artist.instagram_username && artist.instagram_username.length"
                    :href="`${prefixes.INSTAGRAM}${artist.instagram_username}`"
                    class="icon-container"
                >
                    <BaseIcon
                        class="icon"
                        name="logo-instagram"
                    />
                </BaseLink>
                <BaseLink
                    v-if="artist.tiktok_username && artist.tiktok_username.length"
                    :href="`${prefixes.TIKTOK}${artist.tiktok_username}`"
                    class="icon-container"
                >
                    <BaseIcon
                        class="icon"
                        name="logo-tiktok"
                    />
                </BaseLink>
                <BaseLink
                    v-if="artist.website_url && artist.website_url.length"
                    :href="artist.website_url"
                    class="icon-container"
                >
                    <BaseIcon
                        class="icon"
                        name="earth"
                    />
                </BaseLink>
            </div>
        </BaseSection>
    </BaseContent>
</template>

<style lang="scss" scoped>
@import '@design';

.info {
    columns: 320px 2;
    column-gap: $s-m * 2;
    white-space: pre-line;
}

.social-media {
    padding-top: $s-xl;
}

.icon-container {
    position: relative;
    // Centre the glyph in the circle. BaseIcon is inline-block + vertical-align:
    // middle, so in an inline-block box it lines up with the text, 3.4px low.
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    padding: $s-xs;
    overflow: hidden;
    border: 1px solid $c-white;
    border-radius: 50%;
    &::before {
        position: absolute;
        top: 0;
        left: 0;
        z-index: $layer-negative-z-index;
        width: 100%;
        height: 100%;
        content: '';
        background: $c-accent-default;
        opacity: 0;

        @include transition(opacity);
    }
    &:hover {
        border-color: transparent;
        &::before {
            opacity: 1;
        }
    }
}

.icon-container ~ .icon-container {
    margin-left: $s-m;
}

.icon {
    position: relative;
    max-width: 100%;
    max-height: 100%;
    color: $c-white;
}
</style>
